import React from 'react';

export const EventMetadata = ({ event }) => {
  return (
    <div className="flex flex-wrap items-center gap-4 sm:gap-6 mb-4">
      <div className="flex items-center gap-2">
        <img src="/img/icons/calendar.svg" alt="calendar" />
        <p className="font-semibold text-sm text-[#0C0D1A] whitespace-nowrap">
          {new Date(event.eventDate).toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
          })}
        </p>
      </div>

      <div className="flex items-center gap-2">
        <img src="/img/icons/clock.svg" alt="clock" />
        <p className="font-semibold text-sm text-[#0C0D1A]">
          {new Date(event.eventDate).toLocaleTimeString('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
          })}
        </p>
      </div>

      <div className="flex items-center gap-2">
        <img src="/img/icons/map-02.svg" alt="map02" />
        <p className="font-semibold text-sm text-[#0C0D1A]">{event.eventType}</p>
      </div>
    </div>
  );
};
